export default __webpack_public_path__ + "static/media/Backspace_Menn.59411255.png";